import type { ArchivePageEntry } from '~/plugins/archive-pages'

export function useArchivePages() {
  const nuxtApp = useNuxtApp()
  const archivePages = useState<ArchivePageEntry[]>('archive-pages', () => [])

  const glossaryArchive = computed(() => archivePages.value.find(entry => entry.__typename === 'pageGlossaryArchive_Entry'))
  const newsArchive = computed(() => archivePages.value.find(entry => entry.__typename === 'pageArchive_Entry' && 'archiveType' in entry && entry.archiveType === 'journal'))
  const conditionArchive = computed(() => archivePages.value.find(entry => entry.__typename === 'pageArchive_Entry' && 'archiveType' in entry && entry.archiveType === 'condition'))

  function getArchiveSection(sectionHandle: string | undefined) {
    switch (sectionHandle) {
      case 'glossary':
        return glossaryArchive.value
          ? {
              to: toBreadcrumbUrl(glossaryArchive.value.url, { ctx: nuxtApp }),
              label: glossaryArchive.value.title ?? '',
            }
          : undefined
      case 'news':
        return newsArchive.value
          ? {
              to: toBreadcrumbUrl(newsArchive.value.url, { ctx: nuxtApp }),
              label: newsArchive.value.title ?? '',
            }
          : undefined
      case 'condition':
        return conditionArchive.value
          ? {
              to: toBreadcrumbUrl(conditionArchive.value.url, { ctx: nuxtApp }),
              label: conditionArchive.value.title ?? '',
            }
          : undefined
      default:
        return undefined
    }
  }

  return {
    glossaryArchive,
    newsArchive,
    conditionArchive,
    getArchiveSection,
  }
}
